import { get, union } from 'lodash'

import { getUUIDv4 } from '@/src/utils/helper'
import { convertLinkToBackEnd } from '@/src/utils/url'

import { LAYER_TYPE } from '../layer'
import { ALayer } from './ALayer'
import {
  convertNbdsStyleToMapBoxStyle,
  loadStyleImages,
} from './NbdsVectorLayer'

const SOURCE = {}
function createSource(url, select = []) {
  return `${url}?s=${select.join(',')}`
}
export class NbdsRasterLayer extends ALayer {
  get layer_ids() {
    return this.layers.map((x) => x.id)
  }
  constructor(options) {
    let info = options.info
    super({
      metadata: {
        bounds: info.bounds,
        fields: get(info, 'datastore_detail.fields', []),
      },
      type: 'circle',
    })
    this.url = convertLinkToBackEnd(info.tile_link)
    this.layerId = `layer-${getUUIDv4()}`
    this.sourceId = `source-${info.tile_link}`
    let { layers, fields } = convertNbdsStyleToMapBoxStyle(info.style)
    if (!SOURCE[this.url]) {
      SOURCE[this.url] = { fields: [] }
    }
    SOURCE[this.url].fields = union(SOURCE[this.url].fields, fields)
    this.source = {
      url: createSource(this.url, SOURCE[this.url].fields),
      type: 'raster',
    }
    this.info = info
    this.layers = layers
  }
  convertDefaultView(layer_view) {}
  getStyle() {
    return this.layers[0]
  }
  getBeforeId() {
    return this.layers[this.layers.length - 1].id
  }
  async addToMap(map) {
    if (!map.getSource(this.sourceId)) {
      map.addSource(this.sourceId, this.source)
    }
    if (this.image_ids && this.image_ids.length > 0) {
      await loadStyleImages(map, this.image_ids)
    }
    this.layers.forEach((layer, i) => {
      let layer_id = layer.id || `${this.layerId}-${i}`
      layer.id = layer_id
      if (!map.getLayer(layer_id)) {
        let temp = {
          ...layer,
          id: layer_id,
          'source-layer': 'tile-server',
          source: this.sourceId,
          metadata: {
            layer_type: LAYER_TYPE.NBDS_VECTO_LAYER,
            layer_id: this.info.id,
          },
        }
        layer = temp
        map.addLayer(temp)
      }
    })
  }
  removeFromMap(map) {
    this.layers.forEach((layer, i) => {
      let layer_id = layer.id || `${this.layerId}-${i}`

      if (map.getLayer(layer_id)) {
        map.removeLayer(layer_id)
      }
    })
    if (this.layer_label && map.getLayer(this.layer_label.id)) {
      map.removeLayer(this.layer_label.id)
    }
    if (map.getSource(this.sourceId)) {
      map.removeSource(this.sourceId)
    }
  }
  moveLayer(map, beforeId) {
    let temp_before_id = beforeId
    let layers = [...this.layers]
    if (this.layer_label && this.layer_label.id) {
      layers.push(this.layer_label)
    }
    layers.forEach((layer, i) => {
      let layer_id = layer.id || `${this.layerId}-${i}`
      map.moveLayer(layer_id, temp_before_id)
      temp_before_id = layer_id
    })
  }
  toggleShow(map, show) {
    this.layers.forEach((layer, i) => {
      let layer_id = layer.id || `${this.layerId}-${i}`
      map.setLayoutProperty(layer_id, 'visibility', show ? 'visible' : 'none')
    })
  }
  setOpacity(map, opacity) {
    this.layers.forEach((layer, i) => {
      let layer_id = layer.id || `${this.layerId}-${i}`
      let keyOpacity = `${layer.type}-opacity`
      map.setPaintProperty(layer_id, keyOpacity, opacity)
    })
  }
  setStyle(map, style) {
    this.layers.forEach((layer, i) => {
      let layer_id = layer.id || `${this.layerId}-${i}`
      if (map.getLayer(layer_id)) {
        map.removeLayer(layer_id)
      }
    })
    let { layers, fields, image_ids } = convertNbdsStyleToMapBoxStyle(style)
    SOURCE[this.url].fields = union(SOURCE[this.url].fields, fields)
    this.image_ids = image_ids
    this.layers = layers

    if (this.layers[0] && this.layers[0].filter && this.layer_label) {
      this.layer_label.filter = this.layers[0].filter
      map.setFilter(this.layer_label.id, this.layer_label.filter)
    }
    this.resetSource(map)
    this.addToMap(map)
  }
  resetSource(map) {
    map
      .getSource(this.sourceId)
      .setTiles([createSource(this.url, SOURCE[this.url].fields)])
  }
  showLabel(map, show) {}
}
